import PricingBreakdown from "./PricingBreakdown";

function PricingSectionAwaitingApproval({ data }) {
  return (
    <div className="w-full border h-fit border-gray-200 rounded-xl overflow-hidden bg-white mt-4 p-4">
      {/* Header */}
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-lg font-bold text-gray-900">Void</h2>
      </div>

      {/* Content */}
      <div className="bg-primary1/5 p-4 text-sm text-gray-700">
        {/* Per-passenger sections */}
        <PricingBreakdown data={data} />
      </div>
    </div>
  );
}

export default PricingSectionAwaitingApproval;
